(function ($) {


    $(document).on('click', 'a', function (e) {
        var ahref = $(this).attr("href");

        if (ahref === "#bt-form") {
            e.preventDefault();
            $("html, body").animate({scrollTop: 0}, "normal");
            $("div[data-type=businesstaxi]").click();
            return false;
        }

        if (ahref === "#fat-form") {
            e.preventDefault();
            $("html, body").animate({scrollTop: 0}, "normal");
            $("div[data-type=familytaxi]").click();
            return false;
        }

        if(ahref === "#liniowe-form"){
            e.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "normal");
            $("div[data-type=liniowe]").click();
            return false;
        }

        if(ahref === "#berbus-form"){
            e.preventDefault();
            $("html, body").animate({ scrollTop: 0 }, "normal");
            $("div[data-type=berbus]").click();
            return false;
        }

    });


    $(document).ready(function() {
        var locationhref = window.location.hash;

        if (locationhref === "#bt-form") {
            $("html, body").animate({scrollTop: 0}, "normal");
            $("div[data-type=businesstaxi]").click();
        }

        if (locationhref === "#fat-form") {
            $("html, body").animate({scrollTop: 0}, "normal");
            $("div[data-type=familytaxi]").click();
        }

        if(locationhref === "#liniowe-form"){
            $("html, body").animate({ scrollTop: 0 }, "normal");
            $("div[data-type=liniowe]").click();
        }

        if(locationhref === "#berbus-form"){
            $("html, body").animate({ scrollTop: 0 }, "normal");
            $("div[data-type=berbus]").click();
        }
    });


})(jQuery);